module.exports = __webpack_public_path__ + "img/about-ch4-sectors-circular-economy.684e0cf9.png";